import axios from "axios";
import React, { useContext } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { ProfileContext } from "../../contexts/ProfileContext";
import ExperienceSelectorCard from "../common/ExperienceSelectorCard";

const TrainingsSwitch = () => {
  const { peopleData, setPeopleData } = useContext(ProfileContext);
  const [loading, setLoading] = useState(false);
  const params = useParams();
  const id = params?.id;
  const [checked, setChecked] = useState(
    peopleData?.data?.expectedData?.trainings || false
  );

  const handleClick = async () => {
    setLoading(true);
    const value = !checked;
    setChecked(value);

    try {
      await axios.put(`people/${id}`, {
        data: {
          ...peopleData?.data,
          expectedData: {
            ...peopleData?.data?.expectedData,
            trainings: value,
          },
        },
      });

      setPeopleData({
        ...peopleData,
        data: {
          ...peopleData.data,
          expectedData: {
            ...peopleData?.data?.expectedData,
            trainings: value,
          },
        },
      });
      setLoading(false);
    } catch (err) {
      setChecked(!value);
      setLoading(false);
    }
  };

  return (
    <ExperienceSelectorCard
      type="trainings"
      loading={loading}
      selected={checked}
      onClick={handleClick}
    />
  );
};

export default TrainingsSwitch;
